import isObject from '../utility/isObject';

class Result {
  public static fromJson(value: any): Result {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for Result.fromJson(value).');
    }

    const result = value['result'];
    const validValue = value['validValue'];

    return new Result({
      result,
      validValue,
    });
  }

  public result: boolean;
  public validValue: any;

  constructor(
    {
      result = true,
      validValue = null,
    }: {
      result?: boolean,
      validValue?: any,
    }) {
    this.result = result;
    this.validValue = validValue;
  }
}

export default Result;
